import React from "react";
import R14, {
} from "../core";
import RelatedAddForm from "../components/RelatedAddForm";
export default R14.connect(
  class ResourceAlertAddScreen extends React.Component {
    render() {
      return (
        <RelatedAddForm
          name='resourceAlertAddForm'
          formData={this.props.formData}
          domainName='resourceAlert'
          refreshDataTable={this.props.refreshDataTable || 'resourceAlerts'}
          redirect={this.props.redirect || {
            route: "resource",
            params: { uid: this.props.resourceUid }
          }}
          relatedFieldName='resourceUid'
          createButtonTitle='Create Alert'
          createAction={this.props.createAction ||'resourceAlertCreate'}
          // onCreateButtonPress={() => {
          //   this.props.app.nav.replace("resourceScriptCreate", {
          //     uid: this.props.formData.values.resourceUid
          //   });
          // }}
          selectMenuFieldName='alertUid'
          selectMenuFieldLabel='Select Alert'
          selectMenuFieldSelections={this.props.formData.alertSelections}
        />
      );
    }
  }
);